import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { SharedServicesEnvironment, SharedServicesEnvironmentConfig, SERVICES_ENV } from './shared-services.environment';
import { TelemetryService } from './services/telemetry/telemetry.service';
import { LoggerModule } from 'ngx-logger';

@NgModule({
  imports: [CommonModule, LoggerModule.forRoot(undefined)],
  providers: [TelemetryService],
})
export class BenefitsSharedServicesModule {
  static configure<T extends SharedServicesEnvironment>(
    config: SharedServicesEnvironmentConfig<T>
  ): ModuleWithProviders<BenefitsSharedServicesModule> {
    return {
      ngModule: BenefitsSharedServicesModule,
      providers: [
        {
          provide: SERVICES_ENV,
          useExisting: config.sharedServicesEnvironmentType,
        },
      ],
    };
  }
}
